import type { FindPageDetailsResult } from './find-page-details.model';

export interface GenerateFindPageDetailsOptions {
  readonly skill: string;
}

export function generateFindPageDetailsObject({
  skill,
}: GenerateFindPageDetailsOptions): FindPageDetailsResult {
  if (skill === 'php') {
    return {
      id: 'php',
      details: {
        id: 'php',
        seoUrl: 'php',
        metaWorker: 'PHP Developers',
        categoryId: 3,
        phraseWorker: 'PHP Developer',
      },
    };
  }

  const workerName = skill
    .replace(/-/g, ' ')
    .split(' ')
    .filter(word => word)
    .map(word => word.replace(word[0], word[0].toUpperCase()))
    .join(' ');
  return {
    id: skill,
    details: {
      id: skill,
      seoUrl: skill,
      metaWorker: workerName,
      categoryId: 6,
      phraseWorker: workerName,
    },
  };
}
